module.exports = __webpack_public_path__ + "img/urban-fence.e72c3a5b.png";